/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */
'use strict';

const assign = require('./assign');
const isRootContainer = require('./isRootContainer');
const overrideCreateElement = require('./overrideCreateElement');
const React = require('./react');
const ReactDOM = require('./react-dom');
const takeFromMarkup = require('./takeFromMarkup');

const reactData = takeFromMarkup();

/**
 * @function render
 */
module.exports = function (Component, props, targetDOMNode, callback) {
  const fetchedFragments = reactData;

  overrideCreateElement(
    function (originalCreateElement, type, props, children) {
      const args = [].slice.call(arguments, 1);

      if (isRootContainer(type) && fetchedFragments.length) {
        assign(props, fetchedFragments.pop());
      }

      return originalCreateElement.apply(null, args);
    },
    function () {
      assign(props, { createElement: React.createElement });
      ReactDOM.render(React.createElement(Component, props), targetDOMNode, callback);
    }
  );
};
